import React from "react";
import { Container, Row, Col, Card } from "react-bootstrap";

const Footer = () => {
  return (
    <footer
      style={{
        backgroundColor: "#1c1c1c",
        color: "#e5e5e5",
        padding: "40px 0",
      }}
    >
      <Container>
        {/* Footer Links */}
        <Row className="text-center text-md-start">
          <Col md={3} sm={6} className="mb-3">
            <h5 style={{ fontWeight: "bold" }}>$SAVEJAMES</h5>
            <p>
              $SAVEJAMES is more than a coin—it’s a movement. Together, we prove
              that the cryptocurrency revolution can drive meaningful societal
              change.
            </p>
          </Col>
          <Col md={3} sm={6} className="mb-3">
            <h5 style={{ fontWeight: "bold" }}></h5>
            <ul className="list-unstyled">
              <li>
                <a
                  href="https://dexscreener.com/solana/enyvkesxxfeoy8wgpf9hedh7qnfbcxwo9awt3kjk8fyw"
                  style={{
                    color: "#e5e5e5",
                    textDecoration: "none",
                    marginTop: "30px",
                  }}
                >
                  Join{" "}
                  <a
                    href="https://dexscreener.com/solana/enyvkesxxfeoy8wgpf9hedh7qnfbcxwo9awt3kjk8fyw"
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{ textDecoration: "none" }}
                    className="text-white"
                  >
                    <p className="hvr-buzz-out mb-1 me-1">$SAVEJAMES</p>
                  </a>
                  on Solana
                </a>
              </li>
            </ul>
          </Col>
          <Col md={3} sm={6} className="mb-3">
            {/* <h5 style={{ fontWeight: "bold" }}>Sitemap</h5>
            <ul className="list-unstyled">
              <li>
                <a
                  href="#"
                  style={{ color: "#e5e5e5", textDecoration: "none" }}
                >
                  So Home
                </a>
              </li>
              <li>
                <a
                  href="#"
                  style={{ color: "#e5e5e5", textDecoration: "none" }}
                >
                  What is Dogecoin?
                </a>
              </li>
              <li>
                <a
                  href="#"
                  style={{ color: "#e5e5e5", textDecoration: "none" }}
                >
                  Much Wallets
                </a>
              </li>
            </ul> */}
          </Col>
          <Col md={3} sm={6} className="mb-3">
            <h5 style={{ fontWeight: "bold" }}>Pages</h5>
            <ul className="list-unstyled">
              <li>
                <a
                  href="/about"
                  style={{ color: "#e5e5e5", textDecoration: "none" }}
                >
                  About
                </a>
              </li>
              <li>
                <a
                  href="/manifesto"
                  style={{ color: "#e5e5e5", textDecoration: "none" }}
                >
                  Manifesto
                </a>
              </li>
              <li>
                <a
                  href="/vision"
                  style={{ color: "#e5e5e5", textDecoration: "none" }}
                >
                  Vision
                </a>
              </li>
            </ul>
          </Col>
        </Row>
      </Container>
    </footer>
  );
};

export default Footer;
